<template>
  <div class="hlmy">
    <div class="query">
      <van-popover
        v-model="showPopover"
        placement="bottom-start"
        trigger="click"
      >
        <div class="sele-list">
          <p
            v-for="(item, index) in seleList"
            :key="index"
            :class="{ active: num == index }"
            @click="handleList(item, index)"
          >
            <i v-if="num == index" class="iconfont icon-duigou"></i>{{ item }}
          </p>
        </div>
        <template #reference>
          <p class="sele-p">
            {{ p_text
            }}<i
              class="iconfont"
              :class="showPopover ? 'icon-shangsanjiao' : 'icon-xiasanjiao'"
            ></i>
          </p>
        </template>
      </van-popover>
    </div>
    <div class="data-list">
      <h1>FDA批准适应症</h1>
      <div class="show-box"></div>
      <div class="text">
        {{ drugData.fdaNmpa }}
      </div>
    </div>
    <div class="data-list">
      <h1>赞助公司</h1>
      <div class="show-box"></div>
      <div class="text">{{ drugData.company }}</div>
    </div>
    <div class="data-list">
      <h1>医学标准</h1>
      <div class="show-box"></div>
      <div class="text" style="white-space: pre-wrap;" v-html="str"></div>
    </div>
    <div class="data-list">
      <h1>官网链接</h1>
      <div class="show-box"></div>
      <div class="text">{{drugData.url}}</div>
    </div>
  </div>
</template>

<script>
import { cishanDrug, cishanGroup } from "@/api/wxapi.js";

export default {
  data() {
    return {
      num: 0,
      p_text: "",
      seleList: [],
      showPopover: false,
      isActive: false,
      isActive1: true,
      isActive2: false,
      drugData: {},
      str:''
    };
  },
  mounted() {
    this.getGroup();
  },
  methods: {
    getGroup() {
      cishanGroup({
        pageNo: 0,
      }).then((res) => {
        console.log(res);
        this.p_text = res.data[0];
        this.seleList = res.data;
        this.getDrug(res.data[0]);
      });
    },
    getDrug(drugName) {
      cishanDrug({
        pageNo: 0,
        drugName: drugName,
      }).then((res) => {
        console.log(res);
        this.drugData = res.data;
        let str = res.data.medicalStandards.replace(/n/g,'<br>')
        this.str = str.replace('"','').replace(/[\\]/g,'')
      });
    },

    handleList(item, index) {
      this.num = index;
      this.p_text = item;
      this.showPopover = false;
      this.getDrug(item)
    },
    left() {
      this.isActive = false;
      this.isActive1 = true;
      this.isActive2 = false;
    },
    right() {
      this.isActive = true;
      this.isActive1 = false;
      this.isActive2 = true;
    },
  },
};
</script>

<style lang="less" scoped>
.sele-list {
  padding: 15px 24px 0;
  background: #ffffff;
  .active {
    color: #4b84ff;
  }
  p {
    font-size: 13px;
    font-weight: 400;
    color: #2f354d;
    margin-bottom: 20px;
    i {
      font-size: 14px;
      color: #4b84ff;
      margin-right: 10px;
    }
  }
}
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(52, 68, 132, 0) 0%,
    rgba(52, 68, 132, 0.1) 100%
  );
  margin-bottom: 10px;
}
.hlmy {
  padding: 16px;

  .data-list {
    background: @background_color;
    border-radius: 10px;
    padding-bottom: 20px;
    margin-bottom: 20px;
    .text {
      font-size: 14px;
      font-weight: 400;
      color: #5f697d;
      line-height: 28px;
      padding: 0 24px;
      word-break: break-all;
      text-align: justify;
      text-justify: newspaper;
    }
    h1 {
      font-size: 17px;
      font-weight: 500;
      color: #2f354d;
      line-height: 70px;
      position: relative;
      padding-left: 24px;
    }
  }
  .query {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    .sele-p {
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #4b84ff;
      line-height: 18px;
      i {
        font-size: 10px;
        margin-left: 4px;
      }
    }
    .active {
      &::before {
        transition: right 0.3s;
        right: 0 !important;
      }
    }
    .btn-box {
      width: 140px;
      height: 28px;
      line-height: 28px;
      background: #f4f8fd;
      border-radius: 4px;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        transition: right 0.3s;

        right: 50%;
        width: 50%;
        height: 100%;
        box-sizing: border-box;
        background: #ffffff;
        box-shadow: 0px 2px 6px 0px rgba(52, 68, 132, 0.1);
        border-radius: 4px;
        border: 1px solid #d4d6dd;
      }
      span {
        font-size: 13px;
        color: #9095a7;
        width: 50%;
        display: inline-block;
        text-align: center;
        position: relative;
      }
      .active {
        font-weight: 500;
        color: #2f354d;
      }
    }
  }
}
</style>